import { render, staticRenderFns } from "./ApprovalTransferProduct.vue?vue&type=template&id=60741c29&scoped=true"
import script from "./ApprovalTransferProduct.vue?vue&type=script&lang=js"
export * from "./ApprovalTransferProduct.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTransferProduct.vue?vue&type=style&index=0&id=60741c29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60741c29",
  null
  
)

export default component.exports